import { createRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { beforeLoadGeneral } from '@Router/middleware';
import { GeneralSpinner } from '@Components/generalSpinner';
import { handleGenericError } from '@Router/routesUtil/RoutesUtil';
import { LoginOtpVerification } from '@Pages/loginPage/LoginOtpVerification';
import { EmailVerification } from '../index';
import { rootRoute } from './rootRoute';

const emailVerificationQueryParamsSchema = z.object({
  stateToken: z.string(),
});

const emailVerificationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.EMAIL_VERIFICATION].path,
  beforeLoad: () =>
    beforeLoadGeneral({
      page: RoutesMap.EMAIL_VERIFICATION,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: false,
    }),

  component: () => <Suspense fallback={<GeneralSpinner />}>{<EmailVerification />}</Suspense>,
  validateSearch: zodValidator(emailVerificationQueryParamsSchema),
  onError: handleGenericError,
});

const loginOtpVerificationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: routesModel[RoutesMap.LOGIN_OTP_VERIFICATION].path,
  beforeLoad: () =>
    beforeLoadGeneral({
      page: RoutesMap.LOGIN_OTP_VERIFICATION,
      shouldUpdateServerNavStack: false,
      shouldAvoidAuthCheck: true,
    }),
  component: () => <Suspense fallback={<GeneralSpinner />}>{<LoginOtpVerification />}</Suspense>,
});

export const authRoutes = [emailVerificationRoute, loginOtpVerificationRoute];
